import React from 'react';
import { pageSizes, actionColumns, sentToMatisColumns, filteringStateColumnExtensions } from '../../config/constants';
import {
  FilteringState, GroupingState,
  IntegratedGrouping, IntegratedPaging, IntegratedSorting, IntegratedFiltering,
  PagingState, SortingState, DataTypeProvider, SummaryState, IntegratedSummary,
  IntegratedSelection, SelectionState,
} from '@devexpress/dx-react-grid';
import {
  Getter,
  Plugin
} from '@devexpress/dx-react-core';
import {
  Grid,
  DragDropProvider,
  GroupingPanel, PagingPanel,
  Table, TableFilterRow, TableGroupRow,
  TableHeaderRow, Toolbar, 
  TableSelection,
  VirtualTable,
} from '@devexpress/dx-react-grid-material-ui';
import TableCell from '@mui/material/TableCell';
import saveAs from 'file-saver';
import DeselectIcon from '@mui/icons-material/Deselect';
import * as nlMessages from 'devextreme/localization/messages/nl.json';
import { locale, loadMessages } from 'devextreme/localization';

class DevExDataTable extends React.Component {
  
  constructor(props) {
    super(props);

    this.state = {
      locale: 'nl-BE',
      grouping: [],
      selection: [],
      groupSummaryItems: [
        { columnName: 'strQuantity', type: 'sum', showInGroupFooter: false, alignByColumn: true },

      ],
      tableColumnExtensions: [
        { columnName: 'originName', align: 'center' },
        { columnName: 'postCode', align: 'center' },
        { columnName: 'wasteStreamDescription', align: 'center' },
        { columnName: 'materialDescription', align: 'center' },
        { columnName: 'quantity', align: 'right' },
        { columnName: 'uom', align: 'center' },
        { columnName: 'strSentToMatis', align: 'center' },
        { columnName: 'strPeriodValue', align: 'center' },
        { columnName: '', align: 'center' }
      ]
    };

    this.initMessages();
    locale(this.state.locale);
    this.showCheckBoxesModes = ['none', 'onClick', 'onLongTap', 'always'];
    this.selectAllModes = ['allPages', 'page'];
    this.quantityColumns = ['quantity'];


  }
  getLocale() {
    const storageLocale = sessionStorage.getItem('locale');
    return storageLocale != null ? storageLocale : 'nl';
  }


  initMessages() {
    loadMessages(nlMessages);
  }

  render() {

    let gridcolumns = [...this.props.columns];
    if (this.props.hasActions) {
      gridcolumns.push({ name: '', title: '' });
    }

    const onSave = (workbook) => {
      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'DataGrid.xlsx');
      });
    };

    const Root = props => <Grid.Root {...props} style={{ height: '100%' }} />;

    const ActionsFilterCell = ({ filter, onFilter }) => (
      <TableCell sx={{ width: '100%', p: 1 }}>
      </TableCell>
    );

    const FilterCell = (props) => {
      const { column } = props;
      if (column.name === '') {
        return <ActionsFilterCell {...props} />;
      }
      return <TableFilterRow.Cell {...props} />;
    };
    const quantityColumns = ['strQuantity'];
    const priceColumns = ['strPrice'];


    const sumMessages = {
      sum: 'Som',
      contains: 'Bevat',
      notContains: 'Bevat niet',
      startsWith: 'Start met',
      endsWith: 'Eindigd met',
      equal: 'Is gelijk aan',
      notEqual: 'Is niet gelijk aan'

    };
    const tableMessages = {
      sum: 'Som',
      contains: 'Bevat'
    };

    const summaryCalculator = (type, rows, getValue) => {
      var sum = 0;
      rows.forEach(x => sum += parseFloat(x.quantity))
      return sum.toFixed(2)
    };

    const setGrouping = (grouping) => {
      this.setState({ grouping: grouping })
    }

    const QuantityFormatter = ({value}) => 'test';
    const QuantityProvider = props => (
      <QuantityProvider
        formatterComponent={QuantityFormatter}
        {...props}
      />
    );
    const rowSelectionEnabled = (row) => row.requiredForMatis === true;
    class PatchedIntegratedSelection extends React.PureComponent {
      render() {
        const { rowSelectionEnabled, ...restProps } = this.props;
        return (
          <Plugin>
            <Getter
              name="rows"
              computed={({ rows }) => {
                this.rows = rows;
                return rows.filter(rowSelectionEnabled);
              }}
            />
            <IntegratedSelection {...restProps} />
            <Getter
              name="rows"
              computed={() => this.rows}
            />
          </Plugin>
        )
      }
    };
    class PatchedTableSelection extends React.PureComponent {
      render() {
        const { rowSelectionEnabled, ...restProps } = this.props;
        return (
          <TableSelection
            cellComponent={(props) => rowSelectionEnabled(props.tableRow.row) ? (
              <TableSelection.Cell  {...props} />
            ) : (
              <Table.Cell  {...props}><DeselectIcon style={{ color: '#1F8FA5' }}></DeselectIcon></Table.Cell>
            )}
            {...restProps}
          />
        );
      }
    }

    return (<React.Fragment>

      <Grid rows={this.props.data} columns={gridcolumns} rootComponent={Root} >
        <FilteringState columnExtensions={filteringStateColumnExtensions} />
        <SortingState />
        <GroupingState defaultExpandedGroups={[]} grouping={this.state.grouping} onGroupingChange={setGrouping} />
        <SummaryState groupItems={this.state.groupSummaryItems} />
        <PagingState defaultPageSize={100} />
        <SelectionState selection={this.props.selection} onSelectionChange={this.props.setSelection} />

        <IntegratedFiltering />
        <IntegratedSelection />
        <IntegratedSorting messages={sumMessages} />
        <IntegratedGrouping messages={sumMessages} />
        <IntegratedSummary calculator={summaryCalculator} messages={sumMessages} />
        <IntegratedPaging />
        <VirtualTable />
        <DragDropProvider messages={sumMessages} />
        <DataTypeProvider formatterComponent={this.props.sentToMatisFormatter} for={sentToMatisColumns} />
        <DataTypeProvider formatterComponent={this.props.quantityFormatter} for={quantityColumns} />
        <DataTypeProvider formatterComponent={this.props.priceFormatter} for={priceColumns} />

        {this.props.hasActions ? <DataTypeProvider formatterComponent={this.props.ActionFormatter} for={actionColumns} /> : <React.Fragment></React.Fragment>}
        <Table columnExtensions={this.state.tableColumnExtensions} messages={tableMessages} />
        <TableHeaderRow showSortingControls={true} align={'center'} />
        <TableFilterRow showFilterSelector={true} cellComponent={FilterCell} messages={sumMessages} />
        <Toolbar />
        <GroupingPanel showSortingControls={true} messages={{ groupByColumn: "Sleep een kolomkop hierheen om te groeperen op die kolom", sum: "Som", decimalSeparator: ',' }}></GroupingPanel>
        <PatchedTableSelection
          showSelectAll
          rowSelectionEnabled={rowSelectionEnabled}
        />
        {/* <TableSelection showSelectAll rowSelectionEnabled={rowSelectionEnabled}/> */}
        <TableGroupRow messages={sumMessages} />
        <PagingPanel pageSizes={pageSizes} messages={{ showAll: 'Toon alles', rowsPerPage: 'Rijen per pagina', info: '{from} tot {to} ({count} elementen)' }} />

      </Grid>

    </React.Fragment>
    );
  }
}

export default DevExDataTable;
